import { UpdateContactScreenNavigationProps } from "./types"
import React from "react"
import UpdateContact from "./update-contact-screen"
import { PageRoot } from "~screens/page-root"


const UpateContactScreen: React.FC<UpdateContactScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <UpdateContact userId={route.params.userId} />
    </PageRoot>
  )
}

export default UpateContactScreen
